/**
 * Medbook
 * Medbook api
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 */
export type NotificationIconEnum = 'mail' | 'info' | 'newspaper' | 'help' | 'megaphone' | 'warning';

export const NotificationIconEnum = {
    Mail: 'mail' as NotificationIconEnum,
    Info: 'info' as NotificationIconEnum,
    Newspaper: 'newspaper' as NotificationIconEnum,
    Help: 'help' as NotificationIconEnum,
    Megaphone: 'megaphone' as NotificationIconEnum,
    Warning: 'warning' as NotificationIconEnum
};

